module.exports = __webpack_public_path__ + "media/images/fb-b40f9a4248aeab3bee9afea080115df0.svg";